import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index/index.vue'
import interview_mianshilishi from '../views/interview_mianshilishi/index.vue'
import lanhu_mianshilishichongxinmingmingbianji from '../views/lanhu_mianshilishichongxinmingmingbianji/index.vue'
import interview_xuanzeshuziren from '../views/interview_xuanzeshuzirens/index.vue'


Vue.use(VueRouter)

const routes = [

  {
    path: '/chating',
    name: 'chating',
   component: () => import('../views/chatings/index.vue'),
  },
  // {
  //   path: '/demo',
  //   name: 'demo',
  //  component: () => import('../views/demo/index.vue'),
  // },
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index/index.vue'),
  },
  {
    path: '/qzpp',
    name: 'qzpp',
    component: () => import('../views/qzpp/index.vue'),
  },
  {
    path: '/404',
    component: () => import('../views/404.vue'),
  },
  {
    path: '/store',
    component: () => import('../views/store.vue'),
    // redirect: "store/entry",
    redirect: "store/dashboard",
    children: [
      {
        path: 'entry',
        component: () => import('../views/entry/index.vue'),
        redirect: "entry/loginEmail",
        children: [
          {
            path: 'loginEmail',
            component: () => import('../views/entry/loginEmail/index.vue'),
          },
          {
            path: 'loginPwd',
            component: () => import('../views/entry/loginPwd/index.vue'),
          },
          {
            path: 'loginQRCode',
            component: () => import('../views/entry/loginQRCode/index.vue'),
          },
          {
            path: 'forgottenPwd',
            component: () => import('../views/entry/forgottenPwd/index.vue'),
          }
        ]
      },
      {
        path: 'dashboard',
        component: () => import('../views/dashboards/index.vue'),
        redirect: "dashboard/profile",
        children: [
          {
            path: 'profile',
            component: () => import('../views/dashboard/profile/index.vue'),
          },
          {
            path: 'QRCode',
            component: () => import('../views/dashboard/QRCode/index.vue'),
          },
          {
            path: 'phone',
            component: () => import('../views/dashboard/phone/index.vue'),
          },
          {
            path: 'password',
            component: () => import('../views/dashboard/password/index.vue'),
          },
        ]
      },
      {
      path: 'personal',
      redirect: 'personal/basic',
      component: () => import('../views/personal/index.vue'), // 外层布局
      children: [
        { path: 'basic',    name: 'personalBasic',    component: () => import('../views/personal/basic/index.vue'),    meta: { title: '基本信息' } },
        { path: 'resume',   name: 'personalResume',   component: () => import('../views/personal/resume/index.vue'),   meta: { title: '简历管理' } },
        { path: 'security', name: 'personalSecurity', component: () => import('../views/personal/security/index.vue'), meta: { title: '账号安全' } },
        { path: 'general',  name: 'personalGeneral',  component: () => import('../views/personal/general/index.vue'),  meta: { title: '通用设置' } },
        { path: 'privacy',  name: 'personalPrivacy',  component: () => import('../views/personal/privacy/index.vue'),  meta: { title: '隐私设置' } }
      ]
    },
      {
        path: '/Interview_Analysis/:id',
        name: 'Interview_Analysis',
        component: () => import('@/views/Interview_Analysis/index.vue')
      },

      {
        path: 'interview_ing',
        component: () => import('../views/interview_ing/index.vue')
      },
      {
        path: 'interview_pre',
        component: () => import('../views/interview_pre/index.vue')
      },
      {
        path: 'select_metahuman',
        component: interview_xuanzeshuziren
      },
      {
        path: 'Interview_Analysis',
        component: () => import('../views/Interview_Analysis/index.vue'),
      },
    ]
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/dashboards/index.vue'),
  },
  {
    path: '/Interview_Analysis',
    name: 'Interview_Analysis',
    component: () => import('../views/Interview_Analysis/index.vue'),
  },

  {
    path: '/interview_ing',
    name: 'interview_ing',
    component: () => import('../views/interview_ing/index.vue')
  },
  {
    path: '/interview_pre',
    name: 'interview_pre',
    component: () => import('../views/interview_pre/index.vue')
  },

  {
    path: '/interview_mianshilishi',
    name: 'interview_mianshilishi',
    component: interview_mianshilishi
  },
  {
    path: '/interview_xuanzeshuziren',
    name: 'interview_xuanzeshuziren',
    component: interview_xuanzeshuziren
  },
  {
    path: '/more_position',
    name: 'more_position',
    component: () => import('../views/dashboards/MorePosition/index.vue')
  },
  {
    path: '/resume_manage',
    name: 'resume_manage',
    component: () => import('../views/dashboards/ResumeManage/index.vue')
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('../views/demo/demo.vue')
  },

  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404' }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: process.env.NODE_ENV === 'production' ? '' : '/',
  routes
})

// 全局路由错误处理
router.onError((error) => {
  console.error('路由错误:', error);
});

// 捕获导航重复错误
const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

export default router
